jQuery(function ($) {


    $('[js-more-bouteilles]').click(function () {

        $.ajax({
            url: bouteilles_loadmore_params.ajaxurl, // AJAX handler
            data: {
                'action': 'bouteilles_loadmorebutton', // the parameter for admin-ajax.php
                'query': bouteilles_loadmore_params.posts, // loop parameters passed by wp_localize_script()
                'page': bouteilles_loadmore_params.current_page // current page
            },
            type: 'POST',
            beforeSend: function (xhr) {
                $('[js-more-bouteilles]').text(bouteilles_loadmore_params.loading_text); // some type of preloader

            },
            success: function (posts) {
                if (posts) {

                    $('[js-more-bouteilles]').text(bouteilles_loadmore_params.btn_text);
                    $('[js-bouteilles-results]').append(posts); // insert new posts
                    bouteilles_loadmore_params.current_page++;


                    if (bouteilles_loadmore_params.current_page == bouteilles_loadmore_params.max_page)
                        $('[js-more-bouteilles]').hide(); // if last page, HIDE the button

                } else {
                    $('[js-more-bouteilles]').hide(); // if no data, HIDE the button as well
                }
            }
        });
        return false;
    });

});

